import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ChallengePage from "../pages/challenge/page";
import ResultPage from "../pages/result/page";
import LeaderboardPage from "../pages/leaderboard/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/challenge", element: <ChallengePage /> },
  { path: "/result", element: <ResultPage /> },
  { path: "/leaderboard", element: <LeaderboardPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
